import { render, staticRenderFns } from "./PaymentProblemsPanel.vue?vue&type=template&id=60869bdf&scoped=true"
import script from "./PaymentProblemsPanel.vue?vue&type=script&lang=js"
export * from "./PaymentProblemsPanel.vue?vue&type=script&lang=js"
import style0 from "./PaymentProblemsPanel.vue?vue&type=style&index=0&id=60869bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60869bdf",
  null
  
)

export default component.exports